export default "__VITE_ASSET__CxiVkn3z__"